/*************************************************/
/* Accordion                                     */
/*************************************************/


export function accordion() {
    const accordionElementSelector = ".accordion-item__title";
    const activeClass = "accordion-item__title--active";
    const parentActiveClass = "accordion-item--active"

    const init = function () {
        $(accordionElementSelector).each(function() {
            var element = this;
            
            $(element).on('click', function() {
                var target = $(this);
                
                target.toggleClass(activeClass);
                
                $(target.parentNode).toggleClass(parentActiveClass);
                
                var panel = target.next();
                if (panel.css("max-height") !== "0px") {
                    
                    panel.css("max-height", 0); 
                    
                } else {
                    panel.css("max-height", panel[0].scrollHeight); 
                }
            });
        });
        
        window.addEventListener("hashchange", openAccordionItem);
        openAccordionItem();
    };

    const openAccordionItem = function() {
        const url = new URL(window.location.href);
        const elementId = url.hash;
        if($(elementId).length) {
            const $accordionItem = $(elementId).siblings(accordionElementSelector).first();
            if(!$($accordionItem).hasClass(activeClass))
                $($accordionItem).trigger('click');
        }
    }



    init();
}
